import React from 'react';
export function Footer() {
  return <footer className="w-full bg-transparent text-gray-400 py-8 border-t border-[#2A2A2A]" data-id="element-46" data-mp="32wd2cf6gdjt0">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-47" data-mp="3ggtzeln15p6t">
        <div className="text-center space-y-4" data-id="element-48" data-mp="32o48c2sn9u2u">
          <p className="text-gray-400" data-id="element-49" data-mp="32pfci3q053uh">Material educativo profesional.</p>
          <div className="border-t border-[#2A2A2A] pt-6 mt-6" data-id="element-50" data-mp="36qhf8uj4ny17">
            <p className="text-xs text-gray-500 mt-2" data-id="element-51" data-mp="3ufa4671c15mb">
              Este es material educativo de apoyo profesional. No reemplaza la
              formación académica ni la supervisión profesional. Diseñado para
              uso en contextos educativos formales en Argentina.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}